var React = require('react');

function LiquorIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#303c42;stroke-linecap:round;stroke-linejoin:round}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Box_6","data-name":"Box 6"},[React.createElement("path",{"className":"cls-1","d":"M.5 6.5h25v19H.5zm0 0l3-6h19l3 6","key":0}),React.createElement("path",{"className":"cls-1","d":"M10 .5l-.5 6v5h7v-5l-.5-6","key":1})]))]);
}

LiquorIcon.displayName = "LiquorIcon";

LiquorIcon.defaultProps = {"viewBox":"0 0 26 26"};

module.exports = LiquorIcon;

LiquorIcon.default = LiquorIcon;
